import React, {Component} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import {Col, Container, Row} from "react-bootstrap";
import PolicySupportToolResult from "./PolicySupportToolResult";
import SecondMeasureResult from "./SecondMeasureResult";
import {removeUserSession} from "../Utils/Security";
import CustomAlert from "./CustomAlert";
import "./PolicySupportTool.css";

class PolicySupportTool extends Component {

    componentDidMount() {
        this.retrieveImpacts();
        this.retrieveParams();
        this.retrieveUseCases();
        this.retrievePolicyParams();
    }

    state = {
        useCase: '',
        subUseCase: '',
        baseScenario: '',
        enableSecondMeasure: false,
        secondUseCase: null,
        secondSubUseCase: null,
        marginUtilityOfMoney: '0.95',
        secondMarginUtilityOfMoney: '0.95',
        pricingLevel: '0',
        secondPricingLevel: '0',
        gdpPerCapita: '',
        annualGdp: '',
        inflation: '',
        cityPopulation: '',
        urbanShuttleFleetSize: '',
        freightShuttleFleetSize: '',
        averageLoadPerFreightVehicle: '',
        averageAnnualFreightTransportDemand: '',
        annualCityPopulation: '',
        humanDrivenVehicles: '',
        firstGen: '',
        secondGen: '',
        fuelCost: '',
        electricityCost: '',
        fuelConsumption: '',
        electricityConsumption: '',
        travelTime: '',
        vehicleOperationCost: '',
        freightTransportCost: '',
        accessToTravel: '',
        travelSplitPublicTransport: '',
        travelSplitActiveTravel: '',
        shareMobilityRate: '',
        vehicleUtilisationRate: '',
        vehicleOccupancy: '',
        amountOfTravel: '',
        congestion: '',
        parkingSpace: '',
        energyEfficiency: '',
        nox: '',
        co2: '',
        pm10: '',
        publicHealth: '',
        inequalityInTransport: '',
        commutingDistances: '',
        vruCrashRates: '',
        roadSafetyMotorized: '',
        roadSafetyTotalEffect: '',
        vruAccidentShare: '',
        vruReferenceSpeed: '',
        hasError: false,
        errorMessage: null,
        formSubmitted: false,
        submittedSuccessfully: false,
        results: '',
        validated: false,
        impacts: [],
        params: [],
        useCases: [],
        policyParams: [],
        secondPolicyParams: [],
        showMore: false,
        secondShowMore: false,
        toggleOptionsText: 'More',
        secondToggleOptionsText: 'More'
    }

    retrieveImpacts = () => {
        axios.get("/api/pst/impacts", {}).then(resp => {
            this.setState({impacts: resp.data});
            this.state.impacts.forEach((impact) => {
                this.updateImpactValue(impact, impact.defaultValue);
            });
        });
    }

    retrieveParams = () => {
        axios.get("/api/pst/params", {}).then(resp => {
            this.setState({params: resp.data});
            this.state.params.forEach((param) => {
                this.updateParamValue(param, param.defaultValue);
            });
        });
    }

    retrievePolicyParams = () => {
        axios.get("/api/pst/policy_params", {}).then(resp => {
            this.setState({policyParams: resp.data});
            this.setState({secondPolicyParams: JSON.parse(JSON.stringify(resp.data))});
        });
    }

    retrieveUseCases = () => {
        axios.get("/api/pst/use_cases", {}).then(resp => {
            this.setState({useCases: resp.data});
        });
    }

    onSubmit = (event) => {
        let self = this;
        this.setState({formSubmitted: true});
        this.setState({hasError: false});
        this.setState({submittedSuccessfully: false});
        event.preventDefault();

        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            this.setState({validated: true});
            return;
        }

        let firstMeasure = {
            useCase: this.state.useCase,
            subUseCase: this.state.subUseCase,
            marginUtilityOfMoney: this.state.marginUtilityOfMoney,
            pricingLevel: this.state.pricingLevel,
            baseScenario: this.state.baseScenario,
            gdpPerCapita: this.state.gdpPerCapita,
            annualGdp: this.state.annualGdp,
            inflation: this.state.inflation,
            cityPopulation: this.state.cityPopulation,
            urbanShuttleFleetSize: this.state.urbanShuttleFleetSize,
            freightShuttleFleetSize: this.state.freightShuttleFleetSize,
            averageLoadPerFreightVehicle: this.state.averageLoadPerFreightVehicle,
            averageAnnualFreightTransportDemand: this.state.averageAnnualFreightTransportDemand,
            humanDrivenVehicles: this.state.humanDrivenVehicles,
            firstGen: this.state.firstGen,
            secondGen: this.state.secondGen,
            fuelCost: this.state.fuelCost,
            electricityCost: this.state.electricityCost,
            fuelConsumption: this.state.fuelConsumption,
            electricityConsumption: this.state.electricityConsumption,
            travelTime: this.state.travelTime,
            vehicleOperationCost: this.state.vehicleOperationCost,
            freightTransportCost: this.state.freightTransportCost,
            accessToTravel: this.state.accessToTravel,
            travelSplitPublicTransport: this.state.travelSplitPublicTransport,
            travelSplitActiveTravel: this.state.travelSplitActiveTravel,
            shareMobilityRate: this.state.shareMobilityRate,
            vehicleUtilisationRate: this.state.vehicleUtilisationRate,
            vehicleOccupancy: this.state.vehicleOccupancy,
            amountOfTravel: this.state.amountOfTravel,
            congestion: this.state.congestion,
            parkingSpace: this.state.parkingSpace,
            nox: this.state.nox,
            co2: this.state.co2,
            pm10: this.state.pm10,
            publicHealth: this.state.publicHealth,
            inequalityInTransport: this.state.inequalityInTransport,
            commutingDistances: this.state.commutingDistances,
            energyEfficiency: this.state.energyEfficiency,
            annualCityPopulation: this.state.annualCityPopulation,
            vruCrashRates: this.state.vruCrashRates,
            roadSafetyMotorized: this.state.roadSafetyMotorized,
            roadSafetyTotalEffect: this.state.roadSafetyTotalEffect,
            policyParams: this.state.policyParams
        };

        if (this.state.enableSecondMeasure) {
            let secondMeasure = {
                useCase: this.state.secondUseCase,
                subUseCase: this.state.secondSubUseCase,
                marginUtilityOfMoney: this.state.secondMarginUtilityOfMoney,
                pricingLevel: this.state.secondPricingLevel,
                baseScenario: this.state.baseScenario,
                gdpPerCapita: this.state.gdpPerCapita,
                annualGdp: this.state.annualGdp,
                inflation: this.state.inflation,
                cityPopulation: this.state.cityPopulation,
                urbanShuttleFleetSize: this.state.urbanShuttleFleetSize,
                freightShuttleFleetSize: this.state.freightShuttleFleetSize,
                averageLoadPerFreightVehicle: this.state.averageLoadPerFreightVehicle,
                averageAnnualFreightTransportDemand: this.state.averageAnnualFreightTransportDemand,
                humanDrivenVehicles: this.state.humanDrivenVehicles,
                firstGen: this.state.firstGen,
                secondGen: this.state.secondGen,
                fuelCost: this.state.fuelCost,
                electricityCost: this.state.electricityCost,
                fuelConsumption: this.state.fuelConsumption,
                electricityConsumption: this.state.electricityConsumption,
                travelTime: this.state.travelTime,
                vehicleOperationCost: this.state.vehicleOperationCost,
                freightTransportCost: this.state.freightTransportCost,
                accessToTravel: this.state.accessToTravel,
                travelSplitPublicTransport: this.state.travelSplitPublicTransport,
                travelSplitActiveTravel: this.state.travelSplitActiveTravel,
                shareMobilityRate: this.state.shareMobilityRate,
                vehicleUtilisationRate: this.state.vehicleUtilisationRate,
                vehicleOccupancy: this.state.vehicleOccupancy,
                amountOfTravel: this.state.amountOfTravel,
                congestion: this.state.congestion,
                parkingSpace: this.state.parkingSpace,
                nox: this.state.nox,
                co2: this.state.co2,
                pm10: this.state.pm10,
                publicHealth: this.state.publicHealth,
                inequalityInTransport: this.state.inequalityInTransport,
                commutingDistances: this.state.commutingDistances,
                energyEfficiency: this.state.energyEfficiency,
                annualCityPopulation: this.state.annualCityPopulation,
                vruCrashRates: this.state.vruCrashRates,
                roadSafetyMotorized: this.state.roadSafetyMotorized,
                roadSafetyTotalEffect: this.state.roadSafetyTotalEffect,
                policyParams: this.state.secondPolicyParams
            };

            let measures = [firstMeasure, secondMeasure];

            // Request made to the backend api
            // Send formData object
            axios.post("/api/pst/multiple_measure", {
                policySupportTools: measures
            }).then(resp => {
                this.setState({results: resp.data});
                this.setState({submittedSuccessfully: true});
            }).catch(function (error) {
                switch (error.response.status) {
                    case 403:
                        removeUserSession();
                        window.location.href = '/pst';
                        break;
                    default:
                        self.setState({hasError: true});
                        let errorMessage = error.response && error.response.data && error.response.data.length > 0 ?
                            error.response.data[0].description : 'Something went wrong. Please try again'
                        self.setState({errorMessage: errorMessage});
                        break;
                }
            });
        } else {
            // single measure
            axios.post("/api/pst", firstMeasure).then(resp => {
                this.setState({results: resp.data});
                this.setState({submittedSuccessfully: true});
            }).catch(function (error) {
                switch (error.response.status) {
                    case 403:
                        removeUserSession();
                        window.location.href = '/pst';
                        break;
                    default:
                        self.setState({hasError: true});
                        let errorMessage = error.response && error.response.data && error.response.data.length > 0 ?
                            error.response.data[0].description : 'Something went wrong. Please try again'
                        self.setState({errorMessage: errorMessage});
                        break;
                }
            });
        }
    }

    onSelectUseCase(event) {
        this.setState({useCase: event.target.value});
        this.setState({subUseCase: ''});
    }

    onSelectSecondUseCase(event) {
        this.setState({secondUseCase: event.target.value});
        this.setState({secondSubUseCase: ''});
    }

    onSelectSubUseCase(event) {
        this.setState({subUseCase: event.target.value});
    }

    onSelectSecondSubUseCase(event) {
        this.setState({secondSubUseCase: event.target.value});
    }

    onSelectMarginUtilityOfMoney(event) {
        this.setState({marginUtilityOfMoney: event.target.value});
    }

    onSelectSecondMarginUtilityOfMoney(event) {
        this.setState({secondMarginUtilityOfMoney: event.target.value});
    }

    onSelectPricingLevel(event) {
        this.setState({pricingLevel: event.target.value});
    }

    onSelectSecondPricingLevel(event) {
        this.setState({secondPricingLevel: event.target.value});
    }

    onSelectAutomationScenario(event) {
        this.setState({baseScenario: event.target.value});
    }

    onUpdateParamValue(param, event) {
        return this.updateParamValue(param, event.target.value);
    }

    onUpdateImpactValue(param, event) {
        return this.updateImpactValue(param, event.target.value);
    }

    onUpdatePolicyIntensity(intensity, event) {
        this.setState({policyIntensity: event.target.value});
    }

    onUpdatePolicyParam(param, event) {
        this.state.policyParams.forEach((p) => {
            if (p.id === param.id) {
                p.value = event.target.value;
            }
        });
        this.setState({policyParams: this.state.policyParams});
    }

    onUpdateSecondPolicyParam(param, event) {
        this.state.secondPolicyParams.forEach((p) => {
            if (p.id === param.id) {
                p.value = event.target.value;
            }
        });
        this.setState({secondPolicyParams: this.state.secondPolicyParams});
    }

    updateParamValue(param, val) {
        if (!param) {
            return;
        }

        switch (param.id) {
            case 1:
                this.onSelectGDP(val);
                break;
            case 2:
                this.onSelectAnnualGDP(val);
                break;
            case 3:
                this.onSelectInflation(val);
                break;
            case 4:
                this.onSelectCityPopulation(val);
                break;
            case 5:
                this.onSelectAnnualCityPopulation(val);
                break;
            case 8:
                this.onSelectAverageLoadPerFreightVehicle(val);
                break;
            case 9:
                this.onSelectAverageAnnualFreightTransportDemand(val);
                break;
            case 10:
                this.onSelectHumanDrivenVehicles(val);
                break;
            case 11:
                this.onSelectFirstGen(val);
                break;
            case 12:
                this.onSelectSecondGen(val);
                break;
            case 13:
                this.onSelectFuelCost(val);
                break;
            case 14:
                this.onSelectElectricityCost(val);
                break;
            case 15:
                this.onSelectFuelConsumption(val);
                break;
            case 16:
                this.onSelectElectricityConsumption(val);
                break;
            case 17:
                this.onSelectVruReferenceSpeed(val);
                break;
            case 18:
                this.onSelectVruAccidentShare(val);
                break;
            default:
                // do nothing
                break
        }
    }

    updateImpactValue(param, val) {
        if (!param) {
            return;
        }

        switch (param.id) {
            case 1:
                this.onSelectTravelTime(val);
                break;
            case 2:
                this.onSelectVehicleOperationCost(val);
                break;
            case 3:
                this.onSelectFreightTransportCost(val);
                break;
            case 4:
                this.onSelectAccessToTravel(val);
                break;
            case 5:
                this.onSelectAmountOfTravel(val);
                break;
            case 6:
                this.onSelectCongestion(val);
                break;
            case 7:
                this.onSelectTravelSplitPublicTransport(val);
                break;
            case 8:
                this.onSelectTravelSplitActiveTravel(val);
                break;
            case 9:
                this.onSelectShareMobilityRate(val);
                break;
            case 10:
                this.onSelectVehicleUtilisationRate(val);
                break;
            case 11:
                this.onSelectVehicleOccupancy(val);
                break;
            case 12:
                this.onSelectParkingSpace(val);
                break;
            case 14:
                this.onSelectEnergyEfficiency(val);
                break;
            case 15:
                this.onSelectNox(val);
                break;
            case 16:
                this.onSelectCo2(val);
                break;
            case 17:
                this.onSelectPm10(val);
                break;
            case 18:
                this.onSelectPublicHealth(val);
                break;
            case 19:
                this.onSelectInequalityInTransport(val);
                break;
            case 20:
                this.onSelectCommutingDistances(val);
                break;
            case 21:
                this.onSelectVruCrashRates(val);
                break;
            case 22:
                this.onSelectSafetyMotorized(val);
                break;
            case 23:
                this.onSelectRoadSafetyTotalEffect(val);
                break;
            default:
                // do nothing
                break
        }
    }

    onSelectGDP(val) {
        this.setState({gdpPerCapita: val});
    }

    onSelectAnnualGDP(val) {
        this.setState({annualGdp: val});
    }

    onSelectInflation(val) {
        this.setState({inflation: val});
    }

    onSelectCityPopulation(val) {
        this.setState({cityPopulation: val});
    }

    onSelectUrbanShuttleFleetSize(val) {
        this.setState({urbanShuttleFleetSize: val});
    }

    onSelectFreightShuttleFleetSize(val) {
        this.setState({freightShuttleFleetSize: val});
    }

    onSelectAverageLoadPerFreightVehicle(val) {
        this.setState({averageLoadPerFreightVehicle: val});
    }

    onSelectAverageAnnualFreightTransportDemand(val) {
        this.setState({averageAnnualFreightTransportDemand: val});
    }

    onSelectAnnualCityPopulation(val) {
        this.setState({annualCityPopulation: val});
    }

    onSelectHumanDrivenVehicles(val) {
        this.setState({humanDrivenVehicles: val});
    }

    onSelectFirstGen(val) {
        this.setState({firstGen: val});
    }

    onSelectSecondGen(val) {
        this.setState({secondGen: val});
    }

    onSelectFuelCost(val) {
        this.setState({fuelCost: val});
    }

    onSelectElectricityCost(val) {
        this.setState({electricityCost: val});
    }

    onSelectTravelTime(val) {
        this.setState({travelTime: val});
    }

    onSelectElectricityConsumption(val) {
        this.setState({electricityConsumption: val});
    }

    onSelectFuelConsumption(val) {
        this.setState({fuelConsumption: val});
    }

    onSelectAmountOfTravel(val) {
        this.setState({amountOfTravel: val});
    }

    onSelectCongestion(val) {
        this.setState({congestion: val});
    }

    onSelectParkingSpace(val) {
        this.setState({parkingSpace: val});
    }

    onSelectEnergyEfficiency(val) {
        this.setState({energyEfficiency: val});
    }

    onSelectNox(val) {
        this.setState({nox: val});
    }

    onSelectCo2(val) {
        this.setState({co2: val});
    }

    onSelectPm10(val) {
        this.setState({pm10: val});
    }

    onSelectVehicleOperationCost(val) {
        this.setState({vehicleOperationCost: val});
    }

    onSelectFreightTransportCost(val) {
        this.setState({freightTransportCost: val});
    }

    onSelectAccessToTravel(val) {
        this.setState({accessToTravel: val});
    }

    onSelectTravelSplitPublicTransport(val) {
        this.setState({travelSplitPublicTransport: val});
    }

    onSelectTravelSplitActiveTravel(val) {
        this.setState({travelSplitActiveTravel: val});
    }

    onSelectShareMobilityRate(val) {
        this.setState({shareMobilityRate: val});
    }

    onSelectVehicleUtilisationRate(val) {
        this.setState({vehicleUtilisationRate: val});
    }

    onSelectVehicleOccupancy(val) {
        this.setState({vehicleOccupancy: val});
    }

    onSelectPublicHealth(val) {
        this.setState({publicHealth: val});
    }

    onSelectInequalityInTransport(val) {
        this.setState({inequalityInTransport: val});
    }

    onSelectCommutingDistances(val) {
        this.setState({commutingDistances: val});
    }

    onSelectVruReferenceSpeed(val) {
        this.setState({vruReferenceSpeed: val});
    }

    onSelectVruAccidentShare(val) {
        this.setState({vruAccidentShare: val});
    }

    onSelectVruCrashRates(val) {
        this.setState({vruCrashRates: val});
    }

    onSelectSafetyMotorized(val) {
        this.setState({roadSafetyMotorized: val});
    }

    onSelectRoadSafetyTotalEffect(val) {
        this.setState({roadSafetyTotalEffect: val});
    }

    onSelectSecondMeasure(event) {
        let checked = event.target.checked;
        if (!checked) {
            this.setState({secondUseCase: ''});
            this.setState({secondSubUseCase: ''});
        }
        this.setState({enableSecondMeasure: event.target.checked});
    }

    toggleMoreOptions() {
        this.setState({showMore: !this.state.showMore});
        this.setState({toggleOptionsText: this.state.showMore ? 'More' : 'Less'});
    }

    secondToggleMoreOptions() {
        this.setState({secondShowMore: !this.state.secondShowMore});
        this.setState({secondToggleOptionsText: this.state.secondShowMore ? 'More' : 'Less'});
    }

    sendToResult() {
        let useCase = this.state.useCases.find(p => p.id === this.state.useCase);
        let subUseCase = useCase.subUseCases.find(p => p.id === this.state.subUseCase);

        let secondUseCase;
        let secondSubUseCase;

        if (this.state.enableSecondMeasure) {
            secondUseCase = this.state.useCases.find(p => p.id === this.state.secondUseCase);
            secondSubUseCase = secondUseCase.subUseCases.find(p => p.id === this.state.secondSubUseCase);

            return <SecondMeasureResult useCase={useCase} subUseCase={subUseCase} scenario={this.state.baseScenario}
                                            secondUseCase={secondUseCase}
                                            secondSubUseCase={secondSubUseCase} data={this.state.results}/>


        } else {
            return <PolicySupportToolResult useCase={useCase} subUseCase={subUseCase} scenario={this.state.baseScenario}
                                            gdpPerCapita = {this.state.gdpPerCapita}
                                            cityPopulation = {this.state.cityPopulation}
                                            travelSplitActiveTravel = {this.state.travelSplitActiveTravel}
                                            travelSplitPublicTransport = {this.state.travelSplitPublicTransport}
                                            data={this.state.results}/>
        }


    }

    retrieveParam(id) {
        if (this.state.params.length > 0) {
            let obj = this.state.params.find(p => p.id === id);
            return obj.defaultValue;
        }
        return 0;
    }

    renderError() {
        if (this.state.hasError) {
            return <CustomAlert variant={'danger'} message={this.state.errorMessage}/>;
        }
    };

    retrieveImpactDefaultValue(id) {
        return this.state.impacts.find(p => p.id === id);
    }

    searchPage() {
        return <Container>
            <Form noValidate
                  validated={this.state.validated}
                  onSubmit={this.onSubmit}
                  className="mt-4 mb-5">

                <div className="mb-5">
                    <h2 className="text-center">Forecasting module</h2>
                </div>

                <Row>
                    <Col xs={12} md={4}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Use Case</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectUseCase.bind(this)}>
                                <option value="">-- Please Select --</option>
                                {this.state.useCases.map((useCase) => (
                                    <option key={useCase.id} value={useCase.id}>{useCase.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>

                    {this.renderSubUSeCase()}

                    {this.renderBaseScenario()}

                </Row>

                {this.renderExtraParams()}

                <Row className="mt-4 mb-4">
                    <Col xs={12} md={3}>
                        <Button onClick={this.toggleMoreOptions.bind(this)}
                                variant="outline-primary">{this.state.toggleOptionsText}</Button>
                    </Col>
                </Row>

                {this.renderPolicyParams()}


                <Row>
                    <Col xs={12} md={4}>
                        <Form.Check
                            type="checkbox"
                            id="secondMeasure"
                            checked={this.state.enableSecondMeasure}
                            onChange={this.onSelectSecondMeasure.bind(this)}
                            label="Enable Second Measure"
                        />
                    </Col>
                </Row>

                {this.renderSecondMeasure()}


                {this.renderSecondPolicyParams()}

                {this.renderParams()}

                {this.renderImpacts()}

                {this.renderButtons()}


                <Row>
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        {this.renderError()}
                    </Col>
                </Row>
            </Form>
        </Container>
    }

    renderSubUSeCase() {
        let useCase = this.state.useCases.find(useCase => useCase.id === this.state.useCase);

        const subUseCases = useCase && useCase.subUseCases || [];

        return (<Col xs={12} md={4}>
            <Form.Group controlId="subUseCase">
                <Form.Label>Sub-Use Case</Form.Label>
                <Form.Control
                    as="select"
                    disabled={!useCase}
                    onChange={this.onSelectSubUseCase.bind(this)}>
                    <option value="">-- Please Select --</option>
                    {subUseCases.map((subUseCase) => (
                        <option key={subUseCase.id}  disabled={subUseCase.id === this.state.secondSubUseCase}
                                value={subUseCase.id}>{subUseCase.description}</option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Col>)
    }

    renderBaseScenario() {

        return (<Col xs={12} md={4}>
            <Form.Group controlId="baseScenario">
                <Form.Label>Base Scenario (CCAM deployment)</Form.Label>
                <Form.Control
                    as="select"
                    onChange={this.onSelectAutomationScenario.bind(this)}>
                    <option value="">-- Please Select --</option>
                    <option value="SCENARIO_1_NO_AUTOMATION">SCENARIO 1 - NO AUTOMATION</option>
                    <option value="SCENARIO_2_PESSIMISTIC">SCENARIO 2 - PESSIMISTIC</option>
                    <option value="SCENARIO_3_NEUTRAL">SCENARIO 3 - NEUTRAL</option>
                    <option value="SCENARIO_4_OPTIMISTIC">SCENARIO 4 - OPTIMISTIC</option>
                </Form.Control>
            </Form.Group>
        </Col>)
    }

    renderParams() {
        return (
            <div>
                <Row className="section-header">
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        <h5>Parameters</h5>
                        <p className="text-center font-italic">Please enter input parameters</p>
                    </Col>
                </Row>
                <Row>
                    {this.state.params.filter(param => param.id !== 10 && param.id !== 11 && param.id !== 12).map((param) => (
                        <Col key={param.id} xs={12} md={3}>
                            <Form.Group md="12" controlId={param.id}>
                                <Form.Label>{param.description} [{param.measurementUnit}]</Form.Label>
                                <Form.Control type="number" step="any" min="0" lang="en_US"
                                              defaultValue={param.defaultValue}
                                              placeholder={param.defaultValue}
                                              onChange={(e) => this.onUpdateParamValue(param, e)}/>
                                <Form.Text id={param.id} muted>
                                    {param.explanation}
                                </Form.Text>
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    ))}
                </Row>
            </div>
        )
    }


    renderImpacts() {
        const useCase = this.state.useCases.find(p => p.id === this.state.useCase);
        const subUseCases = useCase && useCase.subUseCases || [];
        const nonApplicableImpacts = subUseCases.find(p => p.id === this.state.subUseCase) && subUseCases.find(p => p.id === this.state.subUseCase).nonApplicableImpacts || []

        return (
            <div>
                <Row className="section-header">
                    <Col xs={12} md={{span: 6, offset: 3}}>
                        <h5>Impacts</h5>
                        <p className="text-center font-italic">Please provide initial values based on your city or test network</p>
                    </Col>
                </Row>

                <Row>
                    {this.state.impacts.map((impact) => (
                        <Col key={impact.id} xs={12} md={3}>
                            <Form.Group md="12" controlId={impact.id}>
                                <Form.Label>{impact.impact}</Form.Label>
                                <Form.Control type="number" step="any" min="0" lang="en_US"
                                              aria-describedby={impact.id}
                                              defaultValue={impact.defaultValue}
                                              placeholder={impact.defaultValue}
                                              disabled={nonApplicableImpacts.some(item => item === impact.id)}
                                              onChange={(e) => this.onUpdateImpactValue(impact, e)}/>
                                <Form.Text id={impact.id} muted>
                                    {impact.description}
                                </Form.Text>
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    ))}
                </Row>
            </div>
        )
    }

    renderExtraParams() {
        const display = this.state.subUseCase === 'CITY_TOLLS' || this.state.subUseCase === 'ON_DEMAND_SHUTTLE_BUS_SERVICE';
        if (display) {
            return (<Row className="mt-4">
                {this.renderMarginUtilityOfMoney()}

                {this.renderPricingLevel()}
            </Row>)
        }
    }

    renderSecondExtraParams() {
        const display = this.state.secondSubUseCase === 'CITY_TOLLS' || this.state.secondSubUseCase === 'ON_DEMAND_SHUTTLE_BUS_SERVICE';
        if (display) {
            return (<Row className="mt-4">
                {this.renderSecondMarginUtilityOfMoney()}

                {this.renderSecondPricingLevel()}
            </Row>)
        }
    }

    renderMarginUtilityOfMoney() {
        const display = this.state.subUseCase === 'CITY_TOLLS' || this.state.subUseCase === 'ON_DEMAND_SHUTTLE_BUS_SERVICE';

        if (display) {
            return (
                <Col xs={12} md={3}>
                    <Form.Group controlId="marginUtilityOfMoney">
                        <Form.Label>Marginal utility of money</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={this.onSelectMarginUtilityOfMoney.bind(this)}>
                            <option value="0.95">0,95</option>
                            <option value="1">1</option>
                            <option value="1.05">1.05</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
            )
        }
    }

    renderSecondMarginUtilityOfMoney() {
        const display = this.state.secondSubUseCase === 'CITY_TOLLS' || this.state.secondSubUseCase === 'ON_DEMAND_SHUTTLE_BUS_SERVICE';

        if (display) {
            return (
                <Col xs={12} md={3}>
                    <Form.Group controlId="marginUtilityOfMoney">
                        <Form.Label>Marginal utility of money</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={this.onSelectSecondMarginUtilityOfMoney.bind(this)}>
                            <option value="0.95">0,95</option>
                            <option value="1">1</option>
                            <option value="1.05">1.05</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
            )
        }
    }

    renderPricingLevel() {
        const display = this.state.subUseCase === 'CITY_TOLLS';

        if (display) {
            return (
                <Col xs={12} md={3}>
                    <Form.Group controlId="pricingLevel">
                        <Form.Label>Selection of the pricing level (€)</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={this.onSelectPricingLevel.bind(this)}>
                            <option value="0">0</option>
                            <option value="0.7142857">0,7142857</option>
                            <option value="1.42857142">1,42857142</option>
                            <option value="14.2957142">14,2857142</option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="100">100</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
            )
        }
    }

    renderSecondPricingLevel() {
        const display = this.state.secondSubUseCase === 'CITY_TOLLS';

        if (display) {
            return (
                <Col xs={12} md={3}>
                    <Form.Group controlId="pricingLevel">
                        <Form.Label>Selection of the pricing level (€)</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={this.onSelectSecondPricingLevel.bind(this)}>
                            <option value="0">0</option>
                            <option value="0.7142857">0,7142857</option>
                            <option value="1.42857142">1,42857142</option>
                            <option value="14.2957142">14,2857142</option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="100">100</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
            )
        }
    }

    renderPolicyParams() {
        if (this.state.showMore) {
            return (
                <div>
                    <Row className="section-header">
                        <Col xs={12} md={{span: 6, offset: 3}}>
                            <h5>Policy Parameters</h5>
                        </Col>
                    </Row>
                    <Row className="section-header">
                        <h6>Policy Intensity</h6>
                    </Row>
                    <Row>
                        {this.state.policyParams.filter((param) => param.type === 'POLICY_INTENSITY').map((param) => (
                            <Col key={param.id} xs={2} md={1}>
                                <Form.Group md="12" controlId={param.id}>
                                    <Form.Label>{param.year}</Form.Label>
                                    <Form.Control type="number" step="any" min="0" lang="en_US"
                                                  defaultValue={param.value}
                                                  placeholder={param.value}
                                                  onChange={(e) => this.onUpdatePolicyParam(param, e)}/>
                                    <Form.Control.Feedback type="invalid">
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        ))}
                    </Row>
                    <Row className="section-header">
                        <h6>Policy Effectiveness</h6>
                    </Row>
                    <Row>
                        {this.state.policyParams.filter((param) => param.type === 'POLICY_EFFECTIVENESS').map((param) => (
                            <Col key={param.id} xs={2} md={1}>
                                <Form.Group md="12" controlId={param.id}>
                                    <Form.Label>{param.year}</Form.Label>
                                    <Form.Control type="number" step="any" min="0" lang="en_US"
                                                  defaultValue={param.value}
                                                  placeholder={param.value}
                                                  onChange={(e) => this.onUpdatePolicyParam(param, e)}/>
                                    <Form.Control.Feedback type="invalid">
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        ))}
                    </Row>
                </div>
            )
        }
    }

    renderSecondPolicyParams() {
        if (this.state.secondShowMore) {
            return (
                <div>
                    <Row className="section-header">
                        <Col xs={12} md={{span: 6, offset: 3}}>
                            <h5>Policy Parameters</h5>
                        </Col>
                    </Row>
                    <Row className="section-header">
                        <h6>Policy Intensity</h6>
                    </Row>
                    <Row>
                        {this.state.secondPolicyParams.filter((param) => param.type === 'POLICY_INTENSITY').map((param) => (
                            <Col key={param.id} xs={2} md={1}>
                                <Form.Group md="12" controlId={param.id}>
                                    <Form.Label>{param.year}</Form.Label>
                                    <Form.Control type="number" step="any" min="0" lang="en_US"
                                                  defaultValue={param.value}
                                                  placeholder={param.value}
                                                  onChange={(e) => this.onUpdateSecondPolicyParam(param, e)}/>
                                    <Form.Control.Feedback type="invalid">
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        ))}
                    </Row>
                    <Row className="section-header">
                        <h6>Policy Effectiveness</h6>
                    </Row>
                    <Row>
                        {this.state.secondPolicyParams.filter((param) => param.type === 'POLICY_EFFECTIVENESS').map((param) => (
                            <Col key={param.id} xs={2} md={1}>
                                <Form.Group md="12" controlId={param.id}>
                                    <Form.Label>{param.year}</Form.Label>
                                    <Form.Control type="number" step="any" min="0" lang="en_US"
                                                  defaultValue={param.value}
                                                  placeholder={param.value}
                                                  onChange={(e) => this.onUpdateSecondPolicyParam(param, e)}/>
                                    <Form.Control.Feedback type="invalid">
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        ))}
                    </Row>
                </div>
            )
        }
    }

    renderSecondUseCase() {
        return (<Col xs={12} md={4}>
            <Form.Group controlId="secondUseCase">
                <Form.Label>Second Use Case</Form.Label>
                <Form.Control
                    as="select"
                    onChange={this.onSelectSecondUseCase.bind(this)}>
                    <option value="">-- Please Select --</option>
                    {this.state.useCases.map((useCase) => (
                        <option key={useCase.id}  value={useCase.id}>{useCase.description}</option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Col>)
    }

    renderSecondSubUseCase() {
        let secondUseCase = this.state.useCases.find(useCase => useCase.id === this.state.secondUseCase);

        const subUseCases = secondUseCase && secondUseCase.subUseCases || [];

        return (<Col xs={12} md={4}>
            <Form.Group controlId="secondSubUseCase">
                <Form.Label>Second Sub-Use Case</Form.Label>
                <Form.Control
                    as="select"
                    disabled={!secondUseCase}
                    onChange={this.onSelectSecondSubUseCase.bind(this)}>
                    <option value="">-- Please Select --</option>
                    {subUseCases.map((subUseCase) => (
                        <option key={subUseCase.id} disabled={subUseCase.id === this.state.subUseCase}
                                value={subUseCase.id}>{subUseCase.description}</option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Col>)
    }

    renderSecondMeasure() {
        if (this.state.enableSecondMeasure) {
            return (
                <div>
                    <Row className="mt-4">
                        {this.renderSecondUseCase()}
                        {this.renderSecondSubUseCase()}
                    </Row>
                    {this.renderSecondExtraParams()}
                    <Row className="mt-4 mb-4">
                        <Col xs={12} md={3}>
                            <Button onClick={this.secondToggleMoreOptions.bind(this)}
                                    variant="outline-primary">{this.state.secondToggleOptionsText}</Button>
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    renderButtons() {
        let display = this.state.useCase && this.state.subUseCase && this.state.baseScenario;

        if (this.state.enableSecondMeasure) {
            display = display && this.state.secondUseCase && this.state.secondSubUseCase;
        }

        return (<Row>
            <Col xs={12} md={{span: 6, offset: 3}}>
                <Button disabled={!display} block type="submit">Submit</Button>
            </Col>
        </Row>)
    }

    render() {

        const submittedSuccessfully = this.state.submittedSuccessfully;
        let component;
        if (submittedSuccessfully) {
            component = this.sendToResult();
        } else {
            component = this.searchPage();
        }

        return (
            <div>
                {component}
            </div>
        )
    }


}

export default PolicySupportTool;
